import {TFunction} from 'i18next';

import {formatEuro} from '../numberFormattingUtils/numberFormattingUtils';

import {ApplicantRecruiting, isKeyFactsSalaryRange} from '../../types/shared-recruiting-types';

export const renderSalaryRange = (applicant: ApplicantRecruiting, t: TFunction) => {
  const salary = applicant?.keyFacts?.salary;
  if (!isKeyFactsSalaryRange(salary)) {
    return t('notSpecified');
  }
  if (salary.max == 0 && salary.min == 0) {
    return t('notSpecified');
  }
  if (salary.min && salary.max) {
    return `${formatEuro(salary.min)} - ${formatEuro(salary.max)}`;
  } else if (salary.min) {
    return formatEuro(salary.min);
  } else if (salary.max) {
    return formatEuro(salary.max);
  } else {
    return t('notSpecified');
  }
};
